'use client';

import type { BaseHistogramGlobalFilterItem, GlobalFilterItem } from '@weberus/shared-types';

import { useMemo } from 'react';

import { SubHeader } from '@yanolja-rnd/nol-design-system';
import Histogram from './item/histogram';

interface HistogramTypeFilterProps extends BaseHistogramGlobalFilterItem {
  type: 'HISTOGRAM_NUMBER_RANGE' | 'FLAT_NUMBER_RANGE_WITHOUT_UPPER_LIMIT';
  description?: string;
  onRangeChange: (min: number, max: number) => void;
  onClickHistogramHandle: (serverLogMeta: GlobalFilterItem['serverLogMeta'], minMax: 'min' | 'max') => void;
  onFocusHistogramInput: (serverLogMeta: GlobalFilterItem['serverLogMeta'], minMax: 'min' | 'max') => void;
}

export const HistogramTypeFilter: React.FC<HistogramTypeFilterProps> = ({
  description,
  onRangeChange,
  onClickHistogramHandle,
  onFocusHistogramInput,
  ...filter
}) => {
  const { type, items, title } = filter;
  const isSelected = useMemo(() => items?.[0].selected, [items?.[0].selected]);

  return (
    <section className="px-16 pb-32 pt-16">
      <div className="flex items-center justify-between pr-16">
        <SubHeader.Small title={title} showDotBadge={isSelected} />
        {/* 1박 초과일 때만 노출. 레저 필터는 미노출 */}
        {description && <div className="typography-body-13-regular">{description}</div>}
      </div>

      <Histogram
        isSelected={isSelected}
        onRangeChange={onRangeChange}
        onClickHistogramHandle={onClickHistogramHandle}
        onFocusHistogramInput={onFocusHistogramInput}
        {...filter}
        bins={type === 'HISTOGRAM_NUMBER_RANGE' ? filter.bins : undefined} // 해외숙소 히스토그램은 bins가 없으므로 undefined로 설정
      />
    </section>
  );
};
